<template>
    <layout v-bind:user="user"  v-bind:shops="shops" v-bind:brands="brands" v-bind:company="company" title="運営からのお知らせ詳細">
        <main class="ly_main">
            <div class="wrap">
                <div class="inner">
                    <!--Heading-->
                    <h1 class="heading_page-title flex _y-center">
                        <div class="main"><span>お知らせ詳細</span></div>
                    </h1><!--/.heading_page-title-->

                    <section>

                        <div class="news_component">

                            <div class="md_common-bl _padding-add _flex">
                                <div class="inner">

                                    <!-- LeftColumn -->
                                    <div class="left-col">
                                        <!-- PostTitle -->
                                        <div class="post-title">
                                            <time>{{formatDate(news.created_at)}}</time>
                                            <h2><span>{{ news.title }}</span></h2>
                                        </div>
                                        <!-- PostBody -->
                                        <div class="post-body">
                                            <div class="editor" id="codex-editor" />
                                        </div>
                                    </div><!-- /LeftColumn -->

                                    <!-- RightCol -->
                                    <div class="right-col">

                                        <h3 class="recent-title">
                                            <p class="main"><span>Recent News</span></p>
                                            <p class="sub"><span>最近のお知らせ</span></p>
                                        </h3>

                                        <!-- RecentPosts -->
                                        <ul class="recent-posts">
                                            <li v-for="n in newsList" :key="n.id">
                                                <Link v-if="n.type == 0" :href="route(routeNewsName, n.id)">
                                                    <time>{{formatDate(n.created_at)}}</time>
                                                    <h4 class="title"><span>【運営からのお知らせ】{{n.title}}</span></h4>
                                                </Link>
                                                <Link v-if="n.type == 1 && !n.showroom_id" :href="route(routeTalkName)" :data="{shop_id: n.shop_id, brand_id: n.brand_id}">
                                                    <time>{{formatDate(n.created_at)}}</time>
                                                    <h4 class="title"><span>{{n.message}}</span></h4>
                                                </Link>
                                                <Link v-if="n.type == 1 && n.showroom_id" :href="route(routeTalkName)" :data="{showroom_id: n.showroom_id, brand_id: n.brand_id}">
                                                    <time>{{formatDate(n.created_at)}}</time>
                                                    <h4 class="title"><span>{{n.message}}</span></h4>
                                                </Link>
                                                <p v-if="n.type == 2">
                                                    <time>{{formatDate(n.created_at)}}</time>
                                                    <h4 class="title"><span>{{n.message}}</span></h4>
                                                </p>
                                            </li>
                                        </ul>

                                        <!--btn-link-wrap-->
                                        <div class="btn_link-wrap">

                                            <!--LinkBtn -->
                                            <Link class="btn_link md_icon-text _white" :href="route(routeName)">
                                                <div class="inner">
                                                    <span><div class="icon"><SvgIconBack /></div>一覧へ戻る</span>
                                                </div>
                                            </Link>

                                        </div><!--/.btn-link-wrap-->

                                    </div><!-- /.right-col -->

                                </div>
                            </div><!-- /.md_common-bl -->

                        </div><!-- /.news_componentl -->

                    </section>

                </div><!--/.ly_main .inner-->
            </div><!--/.ly_main .wrap-->
            <div class="heading_page-title-en"><span>{{backName}}</span></div>
        </main>
    </layout>
</template>

<script>
    import AdminLayout from '@/Layouts/AdminLayout'
    import { Link } from '@inertiajs/inertia-vue3'
    import EditorJS from '@editorjs/editorjs'
    import dayjs from 'dayjs'

    import SvgIconBack from '@/components/EndUser/svg/SvgIconBack'


    export default {
        components: {
            "layout": AdminLayout,
            "Link": Link,
            SvgIconBack,
        },
        data() {
            return {
                title: '',
                text: '',
                routeName: '',
                editor: {},
            }
        },
        props: {
            news: Object,
            news_list: Object,
            user: Object,
            company: Object,
            shops: Object,
            brands: Object,
        },
        created() {
            if (location.pathname.match(/shop/)) {
                this.routeName = 'admin.shop.news';
            } else if (location.pathname.match(/brand/)) {
                this.routeName = 'admin.brand.news';
            } else if (location.pathname.match(/showroom/)) {
                this.routeName = 'admin.showroom.news';
            }
        },
        mounted() {
            if (this.news) {
                this.title = this.news.title;
                this.text = this.news.text;
            }
            this.doEditor()
        },
        methods: {
            formatDate: dateStr => dayjs(dateStr).format('YYYY/MM/DD'),
            doEditor() {
                const savedData = this.text ? JSON.parse(this.text) : null
                this.editor = new EditorJS({
                    holder: 'codex-editor',
                    minHeight: 50,
                    readOnly: true,
                    placeholder: 'No content',
                    data: JSON.parse(this.text),
                })
            },
        },
        computed: {
            newsList() {
                if (this.news_list.data) {
                    return this.news_list.data;
                } 
            },
            routeNewsName() {
                if (location.pathname.match(/shop/)) {
                    return 'admin.shop.news.detail';
                } else if (location.pathname.match(/brand/)) {
                    return 'admin.brand.news.detail';
                } else if (location.pathname.match(/showroom/)) {
                    return 'admin.showroom.news.detail';
                }
            },
            routeTalkName() {
                if (location.pathname.match(/shop/)) {
                    return 'admin.shop.talk';
                } else if (location.pathname.match(/brand/)) {
                    return 'admin.brand.talk';
                } else if (location.pathname.match(/showroom/)) {
                    return 'admin.showroom.talk';
                }
            },
            backName() {
                if (this.user.type == 0) {
                    return 'Admin';
                } else if (this.user.type == 1) {
                    return 'Shop';
                } else if (this.user.type == 2) {
                    return 'Brand';
                } else if (this.user.type == 3) {
                    return 'ShowRoom';
                }
            },
        }
    }
</script>
